import React, { useCallback, useEffect, useMemo, useState } from "react";
import { RadioItemInterface } from "../../../models/interfaces/radio-item.interface";
import RadioGroup from "../../../components/form/grouped/radio/radio-group";
import { ReasonFormData } from "../../../models/classes/ApplicationStep1.class";
import { IErrors } from "../../../hooks/use-form";
import {
  P2Alert,
  P2TextInput,
  P2DateSelector,
  P2Checkbox,
  P2TextLabel,
} from "react-bootstrap-common-script";

import { DemiseCurrentOwner } from "../../../utils/shared-dropdown";
import { Helpers } from "../../../utils/helper";
import { OwnershipReasonEnum } from "../../../models/enum/ownership-reason.enum";
import {
  Radio_Cpf_Refund,
  Radio_Divorce_Situation,
  Radio_Has_Outstanding_Loan,
  Radio_Moving_Situations,
  Radio_Submit_Consent,
} from "../../../utils/shared-radio";
import { InfoCard } from "../../../components/info";
import { InfoCircle, InfoSvg } from "../../../assets/svg";
import { ReasonEnum } from "../../../models/enum/reason.enum";
import { HoldingTypeEnum } from "../../../models/enum/holding-type.enum";
import { PolymerAxios } from "../../../utils/axios";
import { useAppSelector } from "../../../redux/hook";
import { API_MOPCheck } from "../../../utils/api";
import moment from "moment";
import { Owner } from "../../../models/polymer/Owner.model";
import { MopCheckStatusEnum } from "../../../models/enum/mop-check-status.enum";
import { DemiseAdministratorDoc } from "../../../models/enum/demise-administrator-doc.enum";
import useCheckLoginIsAdditionalRole from "../../../hooks/use-check-login-role";
import { ApplicationStart } from "../../../models/classes/ApplicationStart.class";

interface ReasonSegmentsProps {
  values: ReasonFormData;
  errors?: IErrors;
  ReasonSegmentsFormHandler: (
    value: string | boolean | string[] | undefined,
    name: string
  ) => void;
  setIsCheckingEligibility: React.Dispatch<React.SetStateAction<boolean>>;
  loginUserStructureStatus?: string;
  currentHoldingType?: string;
  currentOwners?: Owner[];
  forceError?:boolean;
  financialHardshipAdditionalLogic?: any;
  
}

let judgementRadioContent: RadioItemInterface[] = [
  {
    id: 1,
    description: "Yes",
    value: "yes",
    variant: "default",
  },
  {
    id: 2,
    description: "No",
    value: "no",
    variant: "default",
  },
];
interface DemiseOfOwnerStatusInterface {
  isDeathLodged?: boolean;
  isTransmissionDone?: boolean;
}

const getHdbRef = (value?: string) => {
  return value ?? "";
};





function ReasonSegments({ ...props }: ReasonSegmentsProps) {
  const [courtOrderNoDueDate, setCourtOrderNoDueDate] = useState<boolean>(false);
  const [financialAPICalled, setFinancialAPICalled] = useState<boolean>(false);
  const [demiseAPICalled, setDemiseAPICalled] = useState<boolean>(false);
  const [financialAPICalledValid, setFinancialAPIValid] = useState<boolean>(false);

  const [lossOfCitizenshipAPICalled, setLossOfCitizenshipAPICalled] =
    useState<boolean>(false);
  const [lossOfCitizenshipAPICalledValid, setLossOfCitizenshipAPIValid] =
    useState<boolean>(false);
  const [demiseOfOwnerStatus, setDemiseOfOwnerStatus] =
    useState<DemiseOfOwnerStatusInterface>({
      isDeathLodged: undefined,
      isTransmissionDone: undefined,
    });
  const singpassToken = useAppSelector(state => state.auth.AuthenticationSlice.singpassToken);
  const { result:isAdditionalRole } = useCheckLoginIsAdditionalRole()

  const hdb_ref = getHdbRef(
    useAppSelector(
      (state) =>
        state.app.ApplicationStartSlice.formData.selected_hdb_property?.hdb_ref
    )
  );
  const applicationStartFormData = useAppSelector((state) => state.app.ApplicationStartSlice.formData);
  const startApplicationFormData = useAppSelector(state => state.app.ApplicationStartSlice.formData);

  const [isMopMet, setIsMopMet] = useState<boolean>(true);

  const checkMopStatus = useCallback(async (value: string) => {
    try {
      const response = await PolymerAxios("", singpassToken)
        .get(`${API_MOPCheck}/${value}`)
        .then((res) => res.data);
      const result = response.satisfy_mop ?? MopCheckStatusEnum.none;
      const isMet = response.satisfy_mop !== MopCheckStatusEnum.N;//as long as != "N", treated as met in polymer
      props.ReasonSegmentsFormHandler(result, "check_mop_status");
      setIsMopMet(isMet);
    } catch (error) {
      console.log(error);
    }
  }, [props, singpassToken]);


  const demiseHasDocuments = useMemo(()=>{
    return props.values.has_administration_items === DemiseAdministratorDoc.grant_probate_with_last_will || props.values.has_administration_items === DemiseAdministratorDoc.letter_of_administration;
  },[props.values.has_administration_items])

  useEffect(() => {
    if (
      props.values.reason === ReasonEnum.financial_circumstances_reason_value
    ) {
      props.setIsCheckingEligibility(true);
      setTimeout(() => {
        console.log("-----> SMS calling for FINANCIAL");
        const result = true;
        setFinancialAPICalled(true);
        setFinancialAPIValid(result);
        props.ReasonSegmentsFormHandler(result, "check_loan_status");
        props.setIsCheckingEligibility(false);
      }, 1000);
    } else if (
      props.values.reason === ReasonEnum.loss_of_citizenship_reason_value
    ) {
      props.setIsCheckingEligibility(true);
      setTimeout(() => {
        console.log("-----> MOCK API calling for LOSS OF CITIZENSHIP");
        const result = true;
        setLossOfCitizenshipAPICalled(true);
        setLossOfCitizenshipAPIValid(result);
        props.setIsCheckingEligibility(false);
      }, 1000);
    } else {
      setFinancialAPICalled(false);
      setDemiseAPICalled(false);
      setLossOfCitizenshipAPICalled(false);
      // props.ReasonSegmentsFormHandler(undefined, "check_mop_status");
      props.ReasonSegmentsFormHandler(undefined, "check_loan_status");
      props.ReasonSegmentsFormHandler(undefined, "check_cdb_status");
      props.setIsCheckingEligibility(false);
    }
  }, [props.values.reason]);

  useEffect(() => {
    courtOrderNoDueDate === true
    ? props.ReasonSegmentsFormHandler("9999-12-31", "date_of_court_order")
    : props.ReasonSegmentsFormHandler("", "date_of_court_order")
  }, [courtOrderNoDueDate])

  useEffect(() => {
    props.values.date_of_court_order === "9999-12-31"
    ? setCourtOrderNoDueDate(true)
    : setCourtOrderNoDueDate(false)
  }, [props.values.date_of_court_order])

  useEffect(() => {
    if (props.values.reason === ReasonEnum.demise_current_owner_reason_value) {
      props.setIsCheckingEligibility(true);
      setTimeout(() => {
        console.log(
          "-----> Demise of owners data API calling to check for death lodging"
        );
        setDemiseOfOwnerStatus({
          isDeathLodged: true,
          isTransmissionDone: false,
        });
        setDemiseAPICalled(true)
        props.setIsCheckingEligibility(false);
      }, 1000);
    }
  }, [props.values.reason]);

  useEffect(() => {
    props.ReasonSegmentsFormHandler(undefined, "check_mop_status");
    props.setIsCheckingEligibility(true);
    checkMopStatus(hdb_ref).then(() => {
      props.setIsCheckingEligibility(false);
    });
  }, [])

  useEffect(() => {
    if (props.values.reason === ReasonEnum.demise_current_owner_reason_value) {
      const tempArray = []
      if (!checkShouldAskDemiseQuestions("document", applicationStartFormData)) {
        tempArray.push("has_administration_items")
      }

      if (!checkShouldAskDemiseQuestions("date", applicationStartFormData)) {
        tempArray.push("death_date")
      }

      if (!checkShouldAskDemiseQuestions("beneficiary", applicationStartFormData)) {
        tempArray.push("is_beneficiary_proposed_owners")
      }
      props.ReasonSegmentsFormHandler(
        tempArray,
        "validation_exempted_fields"
      );
      
      // if ( props.currentHoldingType === HoldingTypeEnum.joint_tenancy || isAdditionalRole) {
      //   props.ReasonSegmentsFormHandler(
      //     ["has_administration_items"],
      //     "validation_exempted_fields"
      //   );
      // }else if (!(props.currentHoldingType === HoldingTypeEnum.tenancy_in_common && !isAdditionalRole && isAnyOwnerAlive)){
      //   props.ReasonSegmentsFormHandler(
      //     ["has_administration_items"],
      //     "validation_exempted_fields"
      //   );
      // } else if (
      //   props.currentHoldingType === HoldingTypeEnum.tenancy_in_common || isAdditionalRole
      // ) {
      //   if (
      //     props.values.is_beneficiary_proposed_owners === "true" &&
      //     demiseOfOwnerStatus.isTransmissionDone === true
      //   ) {
      //     props.ReasonSegmentsFormHandler(
      //       ["has_administration_items", "death_date"],
      //       "validation_exempted_fields"
      //     );
      //   }
      // }
    }
  }, [ demiseOfOwnerStatus, props.currentHoldingType, applicationStartFormData, isAdditionalRole]);

  let marriageMaxDate = new Date();
  marriageMaxDate.setMonth(marriageMaxDate.getMonth() + 3);
  let marriageMinDate = new Date();
  marriageMinDate.setMonth(marriageMinDate.getMonth() - 3);


  const demiseDateOfDeathMinDate = useMemo(()=>{
    //if additional role, then no restriction  
    // if(!isAdditionalRole){
      let demiseMinDate = new Date();
      return demiseMinDate.setFullYear(demiseMinDate.getFullYear() - 5);
    // }
    // return "";
  },[isAdditionalRole]);

  const handleReasonValues = useCallback((key:string)=>(value:any)=>{
    props.ReasonSegmentsFormHandler(value, key);
  },[props])


  const handleAmountOnBlur = useCallback((key:string)=>(e: any) => {
    if (e) {
      let value = Helpers.formatCurrencyInput(e, true);
      props.ReasonSegmentsFormHandler(value, key);
    }
  },[props])

  const handleAmountOnChange = useCallback((key:string)=>(e: string) => {
    props.ReasonSegmentsFormHandler(e, key);
    let value = Helpers.formatCurrencyInput(e, false);
    props.ReasonSegmentsFormHandler(value, key);
  },[props])



  const handleMovingOutOtherReason = useCallback((value:any)=>{
    props.ReasonSegmentsFormHandler(value, "moving_out_situation");
    props.ReasonSegmentsFormHandler(value,"change_ownership_reason");
  },[props])


  const handleNoDueDate = useCallback(()=>{
    setCourtOrderNoDueDate((prev) => !prev)
  },[]);

  switch (props.values.reason) {
    case ReasonEnum.marital_status_reason_value:
      return (
        <>
          {props.values.reason === ReasonEnum.marital_status_reason_value && (
            <div>
              <RadioGroup
                style={{ marginTop: 32 }}
                required
                label="Which of the following best describes your situation?"
                layout="default"
                hasTooltip={true}
                tooltipContent={`This situation can apply to any current owner.`}
                items={Radio_Divorce_Situation}
                value={props.values.change_ownership_reason}
                onItemSelect={handleReasonValues("change_ownership_reason")}
              />
            </div>
          )}
          {
            //DIVORCE
            props.values.change_ownership_reason ===
              OwnershipReasonEnum.divorce && (
              <>
                <div>
                  <RadioGroup
                    style={{ marginTop: 32 }}
                    required
                    label="Have you obtained the Certificate of Final Judgement or Divorce Certificate?"
                    layout="default"
                    items={judgementRadioContent}
                    value={props.values.have_final_judgement}
                    onItemSelect={handleReasonValues("have_final_judgement")}
                  />
                </div>
                {props.values.have_final_judgement === "yes" && (
                  <>
                    <div style={{ marginTop: 32 }}>
                      <P2DateSelector
                        forceError={props.forceError}
                        isError={!props?.errors?.final_judgement_date?.isValid}
                        errorMsg={props?.errors?.final_judgement_date?.message}
                        value={props.values.final_judgement_date}
                        name="final_judgement_date"
                        onChange={handleReasonValues("final_judgement_date")}
                        required
                        label="Please indicate the Final Judgement/ Certificate of Divorce date"
                        placeholder="DD/MM/YYYY"
                        maxInput={moment()
                          .subtract({ days: 1 })
                          .format("yyyy-MM-DD")}
                      />
                    </div>
                    </>
                )}
                {props.values.have_final_judgement === "no" && (
                  <div style={{ marginTop: 16 }}>
                    <InfoCard style={{ backgroundColor: "#FFF" }} icon={<InfoCircle />} 
                        description={
                          <>
                            <p style={{marginBottom: "24px"}}> 
                              The Final Judgement or Divorce Certificate has to be provided by the completion appointment, failing which HDB will cancel the application and fees will apply.
                            </p>
                            <p>
                              By proceeding, all parties have settled the ancillary matters on the matrimonial property and the custody, care and control of the children (if any).
                            </p>
                          </>
                      } />
                  </div>
                )}

                <div style={{ marginTop: 32 }}>
                  <P2DateSelector
                    forceError={props.forceError}
                    hasTooltip
                    isError={!props?.errors?.date_of_court_order?.isValid}
                    errorMsg={props?.errors?.date_of_court_order?.message}
                    value={props.values.date_of_court_order}
                    name="date_of_court_order"
                    onChange={handleReasonValues("date_of_court_order")}
                    required
                    label="Please indicate the due date to complete the ownership change as shown in the Court Order."
                    placeholder={!courtOrderNoDueDate ? "DD/MM/YYYY" : "Not Applicable"}
                    tooltipContent={
                      "The Court Order may state the deadline to complete the change in flat ownership. For example, within 6 months from the final judgement date, or within 12 months from the order date. Please indicate the due date for the required transaction."
                    }
                    disabled={courtOrderNoDueDate}
                  />
                  <div style={{ marginTop: 8 }}>
                    <P2Checkbox isActive={courtOrderNoDueDate} onClick={handleNoDueDate} description={<P2TextLabel required label={<span className='m-0'>There is no due date indicated in the Court Order</span>} />} />
                  </div>
                </div>
                {props.values.date_of_court_order && moment(props.values.date_of_court_order).isSameOrBefore(moment().add({"months": 3})) &&
                  <div style={{ marginTop: 32 }}>
                  <P2Alert
                    variant={"warning"}
                    text={
                      <p
                        style={{
                          margin: 0,
                          fontSize: 16,
                          color: "#981B25",
                          fontWeight: 500,
                        }}
                      >
                        As the court order deadline is expiring or has expired, applicants would need to engage a private solicitor to act in the conveyancing process to protect all parties' interest as the time has lapsed. HDB will still assess your eligibility in the change in flat ownership.
                      </p>
                    }
                  />
                  </div>}

                <div style={{ marginTop: 32 }}>
                  <P2TextInput
                    forceError={props.forceError}
                    hasTooltip
                    isError={
                      !props.errors?.amount_stated_in_court_order?.isValid
                    }
                    errorMsg={
                      props.errors?.amount_stated_in_court_order?.message
                    }
                    maxLength={30}
                    required
                    value={Helpers.formatThousandSeparator(props.values.amount_stated_in_court_order, "$ ")}
                    name="amount_stated_in_court_order"
                    label="Please indicate the cash consideration amount stated in the Court Order"
                    type="text"
                    onBlur={handleAmountOnBlur("amount_stated_in_court_order")}
                    onChange={handleAmountOnChange("amount_stated_in_court_order")}
                    tooltipContent={
                      "The Court Order may state that there is a cash amount to be given from one party to another, as part of the settlement of the matrimonial home. If any, please indicate the required amount of payment to be settled at the point of completion."
                    }
                  />
                </div>
                <div style={{ marginTop: 32 }}>
                  <RadioGroup
                    style={{ marginTop: 32 }}
                    required
                    label="Amount of CPF refund to outgoing owner:"
                    layout="inline"
                    items={Radio_Cpf_Refund}
                    value={props.values.cpf_refund}
                    onItemSelect={handleReasonValues("cpf_refund")}
                  />
                  <div style={{ marginTop: 32 }}>
                    {/* <InfoCard style={{backgroundColor:"#FFF"}} icon={<InfoSvg />} title={"CPF refund to outgoing owner"} description={"Please select one of the above based on your Court Order."} /> */}
                  </div>
                </div>

                <div style={{ marginTop: 32 }}>
                  <RadioGroup
                    style={{ marginTop: 32 }}
                    required
                    label="I confirm that all current and proposed owners are willing to log in via SingPass to submit their consent for this application, and attend the completion appointment in person."
                    layout="default"
                    items={Radio_Submit_Consent}
                    value={props.values.submit_content}
                    onItemSelect={handleReasonValues("submit_content")}
                  />
                </div>

                {props.values.submit_content === false && (
                  <div style={{ marginTop: 32 }}>
                    <InfoCard
                      style={{ backgroundColor: "#FFF" }}
                      icon={<InfoCircle />}
                      title={"Information for cases with Registrar Clause"}
                      description={
                        "Please note that you will need to engage a Private Lawyer for the transfer, and submit the divorce documents containing the relevant Registrar clause as a supporting document."
                      }
                    />
                  </div>
                )}
              </>
            )
          }

          {
            //INCLUSION DUE TO MARRIAGE
            props.values.change_ownership_reason ===
              OwnershipReasonEnum.inclusion_due_to_marriage && (
              <div style={{ marginTop: 32 }}>
                <P2DateSelector
                  forceError={props.forceError}
                  maxInput={new Date().toISOString().split("T")[0].toString()}
                  isError={!props?.errors?.date_of_marriage?.isValid}
                  errorMsg={props?.errors?.date_of_marriage?.message}
                  value={props.values.date_of_marriage}
                  name="date_of_marriage"
                  onChange={handleReasonValues("date_of_marriage")}
                  required
                  label="Please indicate the date of marriage"
                  placeholder="DD/MM/YYYY"
                />
              </div>
            )
          }


          {
            //MOVING OUT DUE TO MARRIAGE
            props.values.change_ownership_reason ===
            OwnershipReasonEnum.moving_out_due_to_marriage && (
              <div style={{ marginTop: 32 }}>
                <P2DateSelector
                  forceError={props.forceError}
                  maxInput={moment().add({months: 3}).subtract({days: 1}).format('yyyy-MM-DD HH:mm:ss')}
                  isError={!props?.errors?.date_of_marriage?.isValid}
                  errorMsg={props?.errors?.date_of_marriage?.message}
                  value={props.values.date_of_marriage}
                  name="date_of_marriage"
                  onChange={handleReasonValues("date_of_marriage")}
                  required
                  label="Please indicate the date of marriage"
                  placeholder="DD/MM/YYYY"
                />
              </div>
            )}
        </>
      );
    case ReasonEnum.financial_circumstances_reason_value:
      if (!financialAPICalled) {
        return <></>;
      }
      if (financialAPICalledValid) {
        return (
          <>
            {props.financialHardshipAdditionalLogic === 1 && <>
                {props.values.reason === ReasonEnum.financial_circumstances_reason_value && (
                  <div>
                    <RadioGroup
                      style={{ marginTop: 32 }}
                      required
                      label="Do you currently have any outstanding loan or outstanding upgrading costs?"
                      layout="default"
                      items={Radio_Has_Outstanding_Loan}
                      value={props.values.has_outstanding_loan}
                      onItemSelect={handleReasonValues("has_outstanding_loan")}
                    />
                  </div>
                )}
                {props.values.has_outstanding_loan === "no" &&
                  <div style={{ marginTop: 32 }}>
                    <P2Alert
                      variant={"danger"}
                      text={
                        "Based on our checks, there is no outstanding loan due. You would not be able to proceed with an application to change flat ownership on the basis of financial hardship."
                      }
                    />
                  </div>}
                {props.values.has_outstanding_loan === "yes" && (
                  <div style={{ marginTop: 20 }}>
                    <P2TextInput
                      forceError={props.forceError}
                      hasTooltip
                      isError={!props.errors?.outstanding_loan_amount?.isValid}
                      errorMsg={props.errors?.outstanding_loan_amount?.message}
                      maxLength={30}
                      required
                      value={Helpers.formatThousandSeparator(props.values.outstanding_loan_amount, "$ ")}
                      name="outstanding_loan_amount"
                      tooltipContent={"You can obtain the outstanding bank mortgage loan amount from your latest bank statement."}
                      label="Please indicate your outstanding loan amount?"
                      type="text"
                      onBlur={handleAmountOnBlur("outstanding_loan_amount")}
                      onChange={handleAmountOnChange("outstanding_loan_amount")}
                    />
                  </div>
                )}
              </>}

            { props.financialHardshipAdditionalLogic === 99 && <div style={{ marginTop: 32 }}>
                <P2Alert
                  variant={"danger"}
                  text={
                    "Based on our checks, there is no outstanding loan with arrears due. You would not be able to proceed with an application to change flat ownership on the basis of financial hardship."
                  }
                />
              </div>}
          </>
        );
      } else {
        return (
          <div style={{ marginTop: 32 }}>
            <P2Alert
              variant={"danger"}
              text={
                "Based on our records, you do not have any outstanding HDB loan and outstanding upgrading costs. Therefore, you are ineligible for a change in flat ownership based on the selected reason."
              }
            />
          </div>
        );
      }
    case ReasonEnum.demise_current_owner_reason_value:
      if(!demiseAPICalled){
        return <></>;
      }
      if (demiseAPICalled /*demiseOfOwnerStatus */) {
        // valid means the question is never asked or it is asked and the selection is valid
        const isDocumentSelectionValid = !checkShouldAskDemiseQuestions("document", applicationStartFormData) || props.values.has_administration_items !== DemiseAdministratorDoc.no_document

        return (
          <>
            {checkShouldAskDemiseQuestions("document", applicationStartFormData) && (
              <div style={{ marginTop: 32 }}>
                <RadioGroup
                  required
                  label="Do you have the following documents?"
                  layout="default"
                  items={DemiseCurrentOwner.dropdownSelection}
                  value={props.values.has_administration_items}
                  onItemSelect={handleReasonValues(DemiseCurrentOwner.reasonFieldName)}
                />
              </div>
            )}

            {!isDocumentSelectionValid && (
              <div style={{ marginTop: 32 }}>
                <P2Alert
                  variant={"warning"}
                  text={
                    <p
                      style={{
                        margin: 0,
                        fontSize: 16,
                        color: "#981B25",
                        fontWeight: 500,
                      }}
                    >
                      <span style={{ fontWeight: 700 }}>Note: </span>Please provide the documents mentioned above in order to proceed with the change in flat
                      ownership application due to demise of current owners.
                    </p>
                  }
                />
              </div>
            )}

            {isDocumentSelectionValid && checkShouldAskDemiseQuestions("date", applicationStartFormData) && (
              <div style={{ marginTop: 32 }}>
                <P2DateSelector
                  forceError={props.forceError}
                  maxInput={new Date().toISOString().split("T")[0].toString()}
                  isError={!props?.errors?.death_date?.isValid}
                  errorMsg={props?.errors?.death_date?.message}
                  minInput={demiseDateOfDeathMinDate}
                  value={props.values.death_date}
                  name="death_date"
                  onChange={handleReasonValues("death_date")}
                  required
                  label="Please indicate the date of death"
                  placeholder="DD/MM/YYYY"
                />
              </div>
            )}

            {isDocumentSelectionValid && checkShouldAskDemiseQuestions("beneficiary", applicationStartFormData) && (
              <div style={{ marginTop: 32 }}>
                <RadioGroup
                  style={{ marginTop: 32 }}
                  hasTooltip
                  tooltipContent={
                    "Based on the Will (if any) or Intestate Succession Act document, the beneficiaries of the HDB flat are listed in the document. Please indicate if all of the beneficiaries are the proposed owners. Proposed owners refer to the new set of owners after the ownership change."
                  }
                  required
                  label="Are all the beneficiaries listed in the Will or Intestate Succession Act also the proposed owners?"
                  layout="default"
                  items={DemiseCurrentOwner.beneficiariesProposedOwners}
                  value={props.values.is_beneficiary_proposed_owners}
                  onItemSelect={handleReasonValues("is_beneficiary_proposed_owners")}
                />
              </div>
            )}

            {demiseHasDocuments && props.values.is_beneficiary_proposed_owners === "false" && demiseOfOwnerStatus.isTransmissionDone === false && (
              <div style={{ marginTop: 32 }}>
                <InfoCard
                  style={{ backgroundColor: "#FFF" }}
                  icon={<InfoSvg />}
                  title={"Private Lawyer"}
                  description={"Please note that you will need to appoint a private lawyer to act in the conveyancing process."}
                />
              </div>
            )}

            {demiseHasDocuments && props.values.is_beneficiary_proposed_owners === "true" && demiseOfOwnerStatus.isTransmissionDone === true && (
              <div style={{ marginTop: 32 }}>
                <InfoCard
                  style={{ backgroundColor: "#FFF" }}
                  icon={<InfoSvg />}
                  title={"Appointment Lawyer"}
                  description={"Please note that you will need to appoint a private lawyer to act in the conveyancing process."}
                />
              </div>
            )}
          </>
        );
      } else {
        return (
          <div style={{ marginTop: 32 }}>
            <P2Alert variant={"danger"} text={"Based on our records, you do not meet the criteria on demise reason."} />
          </div>
        );
      }

    case ReasonEnum.loss_of_citizenship_reason_value:
      if (!lossOfCitizenshipAPICalled) {
        return <></>;
      }
      if (lossOfCitizenshipAPICalledValid) {
        return (
          <div style={{ marginTop: 32 }}>
            <P2DateSelector
              forceError={props.forceError}
              isError={!props?.errors?.date_of_renunciation?.isValid}
              errorMsg={props?.errors?.date_of_renunciation?.message}
              value={props.values.date_of_renunciation}
              name="date_of_renunciation"
              onChange={handleReasonValues("date_of_renunciation")}
              required
              maxInput={moment().format("yyyy-MM-DD HH:mm:ss")}
              label="Please indicate the date of renunciation of SC/SPR status"
              placeholder="DD/MM/YYYY"
            />
          </div>
        );
      } else {
        return (
          <div style={{ marginTop: 32 }}>
            <P2Alert
              variant={"danger"}
              text={
                <p
                  style={{
                    margin: 0,
                    fontSize: 16,
                    color: "#981B25",
                    fontWeight: 500,
                  }}
                >
                  <span style={{ fontWeight: 700 }}>Note: </span>Based on our checks, there is no loss of citizenship for any owners. You would not be able to
                  proceed with an application to change flat ownership.
                </p>
              }
            />
          </div>
        );
      }
    case ReasonEnum.owner_moving_out_reason_value:
      return (
        <>
          <div style={{ marginTop: 32 }}>
            <RadioGroup
              required
              label="Which of the following best describes your situation?"
              layout="default"
              hasTooltip={true}
              tooltipContent={`This situation can apply to any current owner.`}
              items={Radio_Moving_Situations}
              value={props.values.change_ownership_reason}
              onItemSelect={handleMovingOutOtherReason}
            />
          </div>

          {props.values.change_ownership_reason === OwnershipReasonEnum.moving_out_due_to_marriage && (
            <div style={{ marginTop: 32 }}>
              <P2DateSelector
                forceError={props.forceError}
                required
                label="Please indicate the date of marriage"
                maxInput={moment().add({ months: 3 }).subtract({ days: 1 }).format("yyyy-MM-DD HH:mm:ss")}
                isError={!props?.errors?.date_of_marriage?.isValid}
                errorMsg={props?.errors?.date_of_marriage?.message}
                value={props.values.date_of_marriage}
                name="date_of_marriage"
                onChange={handleReasonValues("date_of_marriage")}
                placeholder="DD/MM/YYYY"
              />
            </div>
          )}
          {props.values.change_ownership_reason === OwnershipReasonEnum.moving_out_others && !isMopMet && (
            <div style={{ marginTop: 32 }}>
              <P2Alert
                variant={"danger"}
                text={
                  <p
                    style={{
                      margin: 0,
                      fontSize: 16,
                      color: "#981B25",
                      fontWeight: 500,
                    }}
                  >
                    A change in flat ownership is not allowed as you have not fulfilled the minimum occupation period.
                  </p>
                }
              />
            </div>
          )}
        </>
      );
    case ReasonEnum.health_reasons_reason_value:
      return (
        <div style={{ marginTop: 32 }}>
          <InfoCard
            style={{ backgroundColor: "#FFF" }}
            icon={<InfoCircle />}
            title={"Medical Memo"}
            description={"Please note that you will need to provide a medical memo stating the medical condition and mental capacity as a supporting document."}
          />
        </div>
      );
    default:
      return <></>;
  }
}

// Helper functions for demise case
function checkShouldAskDemiseQuestions(question: "document" | "date" | "beneficiary", startApplicationFormData: ApplicationStart) {
  const owners = startApplicationFormData.selected_hdb_property?.owners;
  const isThereAnyExecutorOrAdmin = startApplicationFormData.selected_hdb_property?.additional_roles?.some((additionalRole) => additionalRole.role_name === "Executor" || additionalRole.role_name === "Administrator");
  const areAllOwnersAlive = owners && owners?.length > 0 && owners?.every((owner) => owner.live_status === "A");
  const hasDeadOwners = owners?.some(owner => owner.live_status === "D");
  const holdingType = startApplicationFormData.selected_hdb_property?.holding_type;

  switch (question){
    case "document":
      return holdingType !== HoldingTypeEnum.joint_tenancy && hasDeadOwners && !isThereAnyExecutorOrAdmin;
    case "date":
      return areAllOwnersAlive && !isThereAnyExecutorOrAdmin;
    case "beneficiary":
      return holdingType !== HoldingTypeEnum.joint_tenancy && hasDeadOwners && !isThereAnyExecutorOrAdmin;
  }
}

export default ReasonSegments;
